import { Slot } from "@radix-ui/react-slot";
import { forwardRef, type ComponentPropsWithoutRef } from "react";

import { cn } from "core/shadcn/lib/utils";

/**
 * A link styled as text. Renders an `a`. Pass `asChild` with a router
 * `Link`, or with a `<button type="button">` for an action that does not
 * navigate. The border, background and padding resets only matter for the
 * button case.
 */
export const TextLink = forwardRef<
  HTMLElement,
  ComponentPropsWithoutRef<"a"> & { asChild?: boolean }
>(function TextLink({ asChild = false, className, children, ...props }, ref) {
  // Always rendering through Slot keeps the ref typed as HTMLElement, which
  // also fits whatever element asChild passes in.
  return (
    <Slot
      className={cn(
        "cursor-pointer border-0 bg-transparent p-0 text-primary hover:text-primary-hover",
        className,
      )}
      ref={ref}
      {...props}
    >
      {asChild ? children : <a>{children}</a>}
    </Slot>
  );
});
